
// playground requires you to assign document definition to a variable called dd
export const ratesReportPDF = ({products }) => {
    var dd =  {
		content: [
			{ text: 'Rate Card\n', style: "topHeader1" },
			{
				table: {
						body: [
						[
							{ text: 'Product Name', style: "gstHeader" },
							{ text: 'Description', style: "gstHeader"},
							{ text: 'HSN', style: "gstHeader" },
							{ text: 'Rate', style: "gstHeader" },
						],
					
						]
				}
			},
		],
		styles: {
			gstHeader: {
				fontSize: 12,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			topHeader1: {
				fontSize: 14,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d',
			},
		}
	}


    products.map((product) => {
			dd.content[1].table.body.push(
                [
                    { text: product.name  || '-' , style: "data" },
                    { text: product.description || '-' , style: "data"},
                    { text: product.HSN_code  || '-'  , style: "data" },
                    { text: product.sellingPrice || '-' , style: "data" },
                ]
            )
    })
  
    return dd;
}




// WEBPACK FOOTER //
// ./src/utils/pdf-reports/rates-report.js